export default __webpack_public_path__ + "static/media/policy_brief8.412439e4.png";